import React, { useCallback, useEffect, useMemo } from 'react'

import TextArea from './TextArea'
import RichTextEditor from './RichTextEditor'
import { RTMARKSTART, RTMARKEND, MATCHRTMARKSTART, RTMARKSTART2, MATCHTFID } from './rteFuns'
import { useEventHandler, useInstData } from 'tyan/public/hooks'
import RTEDialog from './RTEDialog'

const MultiLines = props => {
	const {
		onChange: onChangePara, value, disabled, placeholder, required, editable, label, richeditable, ...compProps
	} = props

	const { fontSize } = compProps
	const { me, setState, me: { isRTValue, focusStamp, rtFID } } = useInstData(props, useMemo(() => ({
		value,
		isRTValue: value && value.startsWith(MATCHRTMARKSTART(value)) || false, rtFID: value && MATCHTFID(value) || null,
		focusStamp
	}), []))

	const onChange = (value, ...args) => {
		me.value = value
		onChangePara(value, ...args)
	}

	// 传入值与记录不一致
	// if (value != me.value) {
	if (!Tyan.utility.isEqualWithType(value, me.value, 'string')) {
		me.value = value
		// richtext类型变化
		if (isRTValue != (value && value.startsWith(MATCHRTMARKSTART(value)) || false)) {
			me.isRTValue = !isRTValue
			me.focusStamp = Date.now()
			setState({})
		}
	}
	const realValue = useMemo(() => (isRTValue && value) ? value.substring(MATCHRTMARKSTART(value).length, value.length - RTMARKEND.length) : value, [isRTValue, value])

	const handleChange = useMemo(() => isRTValue ? v => onChange(v, false) : onChange, [isRTValue])

	// WordEdit and RTEDialog
	const handleDialogSave = useCallback((newValue, rtFID) => {
		// console.log('newValue:', newValue)
		newValue && (me.isRTValue = true)
		me.rtFID = rtFID
		onChange(newValue ? `${RTMARKSTART2(rtFID)}${newValue}${RTMARKEND}` : newValue || '')
	}, [])

	const handleDialogClose = useCallback(() => {
		me.focusStamp = Date.now()
		setState({})
	}, [])

	const handleWordEdit = useEventHandler(() => {
		// me.richTextEditor.updateValue()
		Tyan.pubForm.showFrontEditor({
			value: realValue && !me.isRTValue && Tyan.utility.newLineToBR(realValue) || realValue, file: rtFID ? { FID: rtFID } : {}, richeditable,
			onSave: ({ html, FID }) => handleDialogSave(html, FID),
			onClose: handleDialogClose,
		})
	})

	const handleShowRTEDialog = useEventHandler(() => {
		Tyan.pubForm.showDialog(label, RTEDialog,
			{
				value: realValue && !me.isRTValue && Tyan.utility.newLineToBR(realValue) || realValue,
				onSave: handleDialogSave, onClose: handleDialogClose,
				fontSize
			},
			{ width: '90%', height: '90%' }
		)
	})

	const handleSwitchToText = useEventHandler((newValue) => {
		me.isRTValue = false
		me.focusStamp = Date.now()
		me.rtFID = 0
		onChange(newValue)
	})

	const commonProps = { enabled: !disabled, placeholder, required, readonly: !editable }
	const sharedProps = {
		commonProps, compProps,
		label, value: realValue, onChange: handleChange, focusStamp, richeditable,
		onWordEdit: handleWordEdit, onShowRTEDialog: handleShowRTEDialog, onSwitchToText: handleSwitchToText
	}

	return isRTValue
		? <RichTextEditor {...sharedProps} />
		: <TextArea {...sharedProps} />
}

export default MultiLines